import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  AddressEntityType,
  BuildingType,
  ObjectType,
  RentalCurrentUsageType,
} from 'types/ApiResponse'
import {
  StyledDataColumn,
  StyledDataContainer,
  StyledDataProperty,
  StyledHeader,
  StyledLine,
  StyledPropertyLabel,
  StyledPropertyValue,
  StyledSectionContainer,
} from '../PropertyInfo.styled'
import checkMarkYes from 'assets/images/icons/checkMarkYes.svg'
import checkMarkNo from 'assets/images/icons/checkMarkNo.svg'

const RentalAndUsageInfo = (props: any) => {
  const { propertyData }: { propertyData: AddressEntityType } = props
  const { t } = useTranslation()

  const getBooleanValue = (value?: boolean) => {
    return (
      <>
        {value ? (
          <img src={checkMarkYes} alt="checkMarkYes" />
        ) : value === false ? (
          <img src={checkMarkNo} alt="checkMarkNo" />
        ) : null}
        {value ? t('common.yes') : value === null ? '—' : value === false ? t('common.no') : '—'}
      </>
    )
  }

  return (
    <StyledSectionContainer>
      <StyledHeader>{t('newAddressModal.objectDataTab.headers.rentAndUsage')}</StyledHeader>
      <StyledDataContainer>
        <StyledDataColumn>
          {propertyData.propertyDetails.objectType !== ObjectType.MULTI_FAMILY_HOUSE && (
            <StyledDataProperty>
              <StyledPropertyLabel>
                {t('newAddressModal.objectDataTab.rentalCurrentUsage')}
              </StyledPropertyLabel>
              <StyledPropertyValue>
                {propertyData?.propertyDetails?.rentalCurrentUsage
                  ? t(
                      `rentalCurrentUsage.${propertyData?.propertyDetails?.rentalCurrentUsage?.toLowerCase()}`
                    )
                  : '—'}
              </StyledPropertyValue>
            </StyledDataProperty>
          )}
          {propertyData.propertyDetails.objectType === ObjectType.APARTMENT &&
            propertyData?.propertyDetails?.rentalCurrentUsage !==
              RentalCurrentUsageType.OWNER_OCCUPIED && (
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.objectDataTab.suitableForOwnUse')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {getBooleanValue(propertyData?.propertyDetails?.suitableForOwnUse)}
                </StyledPropertyValue>
              </StyledDataProperty>
            )}
          {propertyData.propertyDetails.objectType !== ObjectType.MULTI_FAMILY_HOUSE && (
            <StyledDataProperty>
              <StyledPropertyLabel>
                {t('newAddressModal.objectDataTab.headers.coownership')}
              </StyledPropertyLabel>
              <StyledPropertyValue>
                {propertyData?.propertyDetails?.coownershipNumerator
                  ? propertyData?.propertyDetails?.coownershipNumerator
                  : '—'}
                {' / '}
                {propertyData?.propertyDetails?.coownershipDenominator
                  ? propertyData?.propertyDetails?.coownershipDenominator
                  : '—'}
              </StyledPropertyValue>
            </StyledDataProperty>
          )}
          {propertyData.propertyDetails.objectType !== ObjectType.HOUSE && (
            <>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.objectDataTab.rentalInformation.actualRent')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {propertyData?.propertyDetails?.rentalInformation?.actualRent
                    ? propertyData?.propertyDetails?.rentalInformation?.actualRent
                    : '—'}
                </StyledPropertyValue>
              </StyledDataProperty>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.objectDataTab.rentalInformation.actualRentReference')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {propertyData?.propertyDetails?.rentalInformation?.actualRentReference
                    ? t(
                        `rentalReference.${propertyData?.propertyDetails?.rentalInformation?.actualRentReference?.toLowerCase()}`
                      )
                    : '—'}
                </StyledPropertyValue>
              </StyledDataProperty>
            </>
          )}
        </StyledDataColumn>
        <StyledDataColumn>
          {propertyData?.propertyDetails?.buildingType ===
            BuildingType.RESIDENTIAL_AND_COMMERCIAL && (
            <>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.objectDataTab.rentalInformation.actualCommercialRent')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {propertyData?.propertyDetails?.rentalInformation?.actualCommercialRent
                    ? propertyData?.propertyDetails?.rentalInformation?.actualCommercialRent
                    : '—'}
                </StyledPropertyValue>
              </StyledDataProperty>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t(
                    'newAddressModal.objectDataTab.rentalInformation.actualCommercialRentReference'
                  )}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {propertyData?.propertyDetails?.rentalInformation?.actualCommercialRentReference
                    ? t(
                        `rentalReference.${propertyData?.propertyDetails?.rentalInformation?.actualCommercialRentReference?.toLowerCase()}`
                      )
                    : '—'}
                </StyledPropertyValue>
              </StyledDataProperty>
            </>
          )}
        </StyledDataColumn>
      </StyledDataContainer>
      <StyledLine />
    </StyledSectionContainer>
  )
}

export default RentalAndUsageInfo
